// DateRangerPicker.js

import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar } from 'lucide-react';

export default function DateRangePicker({ 
  startDate, 
  endDate, 
  onChange, 
  placeholder = 'Selecione o período',
  className = '' // Adicionado para aceitar classes externas
}) {
  const [dateRange, setDateRange] = useState([startDate, endDate]);
  const [start, end] = dateRange;

  useEffect(() => {
    setDateRange([startDate, endDate]);
  }, [startDate, endDate]);

  const handleChange = (update) => {
    setDateRange(update);
    const [newStart, newEnd] = update;
    
    // Call parent onChange with formatted dates
    if (onChange) {
      onChange({
        startDate: newStart,
        endDate: newEnd
      });
    }
  };

  return (
    // A classe 'className' agora é aplicada aqui
    <div className={`relative ${className}`}> 
      <DatePicker
        selectsRange={true}
        startDate={start}
        endDate={end}
        onChange={handleChange}
        placeholderText={placeholder}
        dateFormat="dd/MM/yyyy"
        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        wrapperClassName="w-full"
        isClearable={true}
      />
      <Calendar className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
    </div>
  );
}